var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_336_3230",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 47
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.048584,
    width: 48.1429,
    height: 47,
    rx: 4,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_336_3230)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 15.8C7 14.527 7.44777 13.3061 8.2448 12.4059C9.04183 11.5057 10.1228 11 11.25 11H27.1875C28.2183 10.9999 29.2141 11.4229 29.9893 12.1902C30.7645 12.9576 31.2663 14.017 31.4014 15.1712L38.0101 11.8544C38.3336 11.6916 38.688 11.6227 39.041 11.654C39.3941 11.6852 39.7346 11.8156 40.0317 12.0333C40.3288 12.2511 40.573 12.5492 40.7421 12.9006C40.9112 13.252 40.9998 13.6456 41 14.0456V31.9544C40.9997 32.3541 40.911 32.7473 40.742 33.0984C40.573 33.4496 40.3291 33.7475 40.0323 33.9652C39.7355 34.1828 39.3953 34.3133 39.0425 34.3448C38.6898 34.3763 38.3356 34.3079 38.0122 34.1456L31.4014 30.8288C31.2663 31.983 30.7645 33.0424 29.9893 33.8098C29.2141 34.5771 28.2183 35.0001 27.1875 35H11.25C10.1228 35 9.04183 34.4943 8.2448 33.5941C7.44777 32.6939 7 31.473 7 30.2V15.8ZM31.4375 28.22L38.875 31.9544V14.0456L31.4375 17.78V28.22ZM11.25 13.4C10.6864 13.4 10.1459 13.6529 9.7474 14.1029C9.34888 14.553 9.125 15.1635 9.125 15.8V30.2C9.125 30.8365 9.34888 31.447 9.7474 31.8971C10.1459 32.3471 10.6864 32.6 11.25 32.6H27.1875C27.7511 32.6 28.2916 32.3471 28.6901 31.8971C29.0886 31.447 29.3125 30.8365 29.3125 30.2V15.8C29.3125 15.1635 29.0886 14.553 28.6901 14.1029C28.2916 13.6529 27.7511 13.4 27.1875 13.4H11.25Z",
    fill: "#595959"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadVideo);
export default __webpack_public_path__ + "static/media/uploadVideo.fa8712e9d18a32f12a36ab111e46888e.svg";
export { ForwardRef as ReactComponent };